/*jslint white: true, nomen: true, unparam : true, es5: true */
/*global document, window, Cookies, jQuery */
jQuery( document ).ready(function($) {
    "use strict";
    
    $('.gotostep').click(function(){
	var step = $(this).data('id');
	$('.etapes > div').removeClass('sel');
	$('.etapes > div:nth-child(3)').addClass('sel');
	$('.etape1').hide();
	$('.etape2').show();
    });
    $('.etapes > div').click(function(){
	$('.etapes > div').removeClass('sel');
	$(this).addClass('sel');
	var step = $(this).data('id')
	$('.etape1').hide();
	$('.etape2').hide();
	$('.etape'+step).show();
    });

    // Chargment des commentaires en Ajax
    $('#form-field-agence').change(function (e) {
	console.log($(this).val());
	// Empêcher l'envoi classique du formulaire
	e.preventDefault();

	// L'URL qui réceptionne les requêtes Ajax dans l'attribut "action" de <form>

	const ajaxurl = '/wp-admin/admin-ajax.php';

	// Les données de notre formulaire
	// ⚠️ Ne changez pas le nom "action" !
	const data = {
	    action: 'load_agences', 
	    cp_ville: $(this).val(),
	}


	// Requête Ajax en JS natif via Fetch
	fetch(ajaxurl, {
	    method: 'POST',
	    headers: {
		'Content-Type': 'application/x-www-form-urlencoded',
		'Cache-Control': 'no-cache',
	    },
	    body: new URLSearchParams(data),
	})
	    .then(response => response.json())
	    .then(response => {
		console.log(response);

		// En cas d'erreur
		if (!response.success) {
		    alert(response.data);
		    return;
		}

		$('#form-field-agence').val(response.data);

	    });
    });
});
